module.exports = __webpack_public_path__ + "assets/images/configuration.5a3659f2f7b562c6ba0c2c49685e0f8e.svg";